//Core
import React, { useState, useEffect } from "react";

//Styles
import "./styles.scss";

//Redux
import { useDispatch, useSelector } from "react-redux";
import { getApprovalListRequest_ACCESSOR } from "../../../../Redux/Slices/Approver/approverSlice";

//Component
import MainLayout from "Layouts/Main";
import NormalTable from "Components/NormalTable";
import Button from "Components/Button";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import InputBox from "Components/InputBox";
import { FaRegEye } from "react-icons/fa";
import Colors from "../../../../Assets/SassConstants/colors.scss";
import InstructionsModalForAssessor from "../../../../Components/InstructionsModal/InstructionsModalForApprover";

const Approval = () => {
  //Initialize redux
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [approvalList, setApprovalList] = useState([]);
  const [sort, setSort] = useState({
    sortBy: null,
    sortOrder: 0,
  });
  const [search, setSearch] = useState("");
  const isLoading = useSelector((state) => state.approver.isLoading);
  const navigate = useNavigate();

  // Modal control
  const [showInstructions, setShowInstructions] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const assessmentTrackerHeader = [
    { label: "S.No", isSort: false, key: "sno" },
    { label: "Company name", isSort: true, key: "company_name" },
    { label: "Reference Number", isSort: true, key: "reference_name", headerStyle: { paddingInline: "15px" }},
    { label: "Submitted date", isSort: true, key: "submitted_on" },
    { label: "Assessor Name", isSort: true, key: "assessor_name" },
    { label: "Completed on", isSort: true, key: "reviewed_on" },
    { label: "Actions", isSort: false, key: "actions" },
  ];

  useEffect(() => {
    getApprovalListRequest_ACCESSOR_(currentPage);
  }, [sort, search]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = async (page) => {
    getApprovalListRequest_ACCESSOR_(page);
    await setCurrentPage(page);
  };

  const getApprovalListRequest_ACCESSOR_ = (page) => {
    dispatch(
      getApprovalListRequest_ACCESSOR({
        page: page,
        search,
        sortBy: sort.sortOrder === 1 ? "ASC" : "DESC",
        orderBy: sort.sortBy,
        limit: 8,
        callBack: getApprovalListRequestCB_ACCESSOR,
      })
    );
  };

  const getApprovalListRequestCB_ACCESSOR = (data) => {
    setTotalPages(data?.data?.pageMeta?.totalPages || 0);
    setApprovalList(data?.data?.data_list || []);
  };

  const getDisplayedIndex = (currentPage, index) => {
    return (currentPage - 1) * 8 + 1 + index;
  };

  const handleContinue = () => {
    setShowInstructions(false);
    if (selectedItem) {
      navigate(`/approval/view-detail/${selectedItem?.backlog_id}`, {
        state: {
          company_name: selectedItem?.company_name,
          assessment_id: selectedItem?.backlog_id,
          assessor_id: selectedItem?.assessor_id,
        },
      });
    }
  };

  return (
    <MainLayout>
      <div className="assessment-tracker-container ps-4 ms-2">
        <div className="row">
          <div className="d-flex justify-content-between align-items-center">
            <label className="assessmentTrackerTitle">Approval</label>
            <div className="me-3">
              <InputBox
                name="search"
                isSearch={true}
                placeholder="Search"
                value={search}
                onChange={handleSearch}
                inputStyle={{ width: "277px" }}
              />
            </div>
          </div>
        </div>

        <div className="mt-3">
          <NormalTable
            loading={isLoading === "loading"}
            headers={assessmentTrackerHeader}
            sort={sort}
            setSort={setSort}
            currentPage={currentPage}
            noDataColspan={6}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            customStyle={{
              customTableHeaderContainer: "customApprovalTableHeader",
              customHeaderTitle: "customApprovalHeaderStartTitle",
              customTable: "customApprovalTable",
              customTableContainer: "customApprovalTableContainer",
            }}
            noDataLabel={approvalList?.length === 0}
          >
            {approvalList?.map((item, index) => (
              <tr key={index}>
                <td>
                  <div className="TableDivisionStart ms-5 ps-2">
                    {getDisplayedIndex(currentPage, index)}
                  </div>
                </td>
                <td>
                  <div className="TableDivisionStart ms-2">
                    {item?.company_name ?? "-"}
                  </div>
                </td>
                <td>
                  <div className="TableDivisionStart ms-2" style={{ paddingInline: "15px" }}>
                    {item?.reference_name ?? "-"}
                  </div>
                </td>
                <td>
                  <div className="TableDivisionStart ms-2">
                    {!!item?.submitted_on ? moment(item?.submitted_on).format("DD/MM/YYYY") : "-"}
                  </div>
                </td>
                <td>
                  <div className="TableDivisionStart ms-2">
                    {item?.assessor_name ?? "-"}
                  </div>
                </td>
                <td>
                  <div className="TableDivisionStart ms-2">
                    {!!item?.reviewed_on ? moment(item?.reviewed_on).format("DD/MM/YYYY") : "-"}
                  </div>
                </td>
                <td>
                  <div className="TableDivisionStart mt-1">
                    <FaRegEye
                      onClick={() => {
                        setSelectedItem(item);
                        setShowInstructions(true);
                      }}
                      size={25}
                      color={Colors.grey_17}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </NormalTable>
        </div>
      </div>

      {/* Instructions Modal - only one instance outside the table map */}
      <InstructionsModalForAssessor
        isOpen={showInstructions}
        onClose={() => setShowInstructions(false)}
        onContinue={handleContinue}
        Button={Button}
      />
    </MainLayout>
  );
};

export default Approval;
